<div *ngIf="isLanding; else isNotLanding">
  <router-outlet></router-outlet>
</div>
<ng-template #isNotLanding>
  <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">
      <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
          <div class="column-control aem-GridColumn aem-GridColumn--default--12">
              <div class="column-control-wrapper full-bleed-container layout-padding">
                  <div class="full-bleed-row">
                      <div class="container-fluid">
                          <div class="row">
                              <div *ngIf="!hideUCALeftNav" class="contentdiv col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                                  <div class="experiencefragment section">
                                      <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
                                          <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">
                                              <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
                                                  <uca-navigation></uca-navigation>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="asidediv col-12 col-sm-12 col-md-12"
                                  [ngClass]="hideUCALeftNav ? 'col-lg-12 col-xl-12' : 'col-lg-9 col-xl-9'">
                                  <router-outlet></router-outlet>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>  
</ng-template>
